module.exports = __webpack_public_path__ + "static/1306145377.5191c3a6.jpg";